<template>
  <div class="hello">
    <div class="subTitle">洪湖天立小初</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'hhtlxc',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=xNfAx9eiKGd8f37edaf21f4373DFDz2lVKJtBVxpyfBRJQBjUuSCXWvOOrPIYMscRSSLhXB0AAOxOLZg9irjiVzeAjBujQfGEE8QMX2cJ2yJdRPoTwu4oV3JE+Ajw/BHXBRqIrV88Zy3dHC16WQHR3gs+7/GkvGxLRiTWFjMDt9Lyfabe0yxZZMr/Zo='
        },
        {
          label: '小初餐费',
          url: 'https://common-cspay.cibfintech.com/?data=xNfAx9eiKGd8f37edaf21f4373DFDz2lVKJtBXCteNeRQdVJG0raoKIgFmlXkMuWCbuSxub8xMoQ4mtc1USscPHHwqmqDKUIzKj/rXEVgYPTynA5n/6jhnL3ojVa/Ao77m9sqOBWY/rPDWPU9v4Zpf/UfeEaZbY0SfYFuUNzWhW3EVZ1jChyVMeq72Y='
        },
        {
          label: '素养费',
          url: 'https://common-cspay.cibfintech.com/?data=xNfAx9eiKGd8f37edaf21f4373DFDz2lVKJtBexidVjsRSUTvf7bL/4O9HP63dyznoQgyuFbUck0457mMqxnl00tGlmxiptGcMvGGo1R2e0W7K/ZQGKph/IdPwSyMzIiCV/pza4heFM59TDYDD+3TzqZib+5aUb9UAic15MPwWIqFN5J4kU6435q4lY='
        },
        {
          label: '综合服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM5qZWR0rjPJHGJmsdKpBlP2fyGfO1PplN6gkIH5lgsNUv8NPWyucPHivzsQuw4t5hDvLzdLnIhGhc8P0ermcXTXpTsm5VzfTNMddeQeT2gbXyRDEd92KRl/URi6kjZYkKeHjTGdP+R/oFVXxuZ4TT3E='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '洪湖天立小初';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

